import React from 'react'
import { useAction } from '../../utils/react-redux'
import s from './OutdoorButton.less'
import SVGIcon from '../../svg/SVGIcon'
import { displayOutdoor, hideOutdoor } from '../../../store/ui/ui.actions'
import { OUTDOOR_STATUS_PROMPT } from '../../outdoor/Utils'
import useTooltip from './useTooltip'
import classNames from 'classnames'
import T from '../../i18n/T'
import { selectIsOutdoorPrompted } from '../../../store/ui/ui.outdoor.selectors'
import { useSelector } from 'react-redux'
import useEventCallback from '../../utils/useEventCallback'
import TagActionButton from '../../genericComponents/TagActionButton'
import { TAG_UPI_IMMERSIVE } from '../../../store/analytics/analytics.actionTypes'

const OutdoorButton = () => {
  const statusIsPrompt = useSelector(selectIsOutdoorPrompted)
  const execDisplayOutdoor = useAction(displayOutdoor)
  const execHideOutdoor = useAction(hideOutdoor)
  const { tooltip, setTooltip, mouseListeners } = useTooltip()

  const onButtonClick = useEventCallback(() => {
    setTooltip(false)
    if (statusIsPrompt) {
      execHideOutdoor()
    } else {
      execDisplayOutdoor({ status: OUTDOOR_STATUS_PROMPT })
    }
  }, [statusIsPrompt, execHideOutdoor, execDisplayOutdoor])

  return (
    <div className={s.root}>
      <TagActionButton
        type={TAG_UPI_IMMERSIVE}
        className={classNames(s.button, statusIsPrompt && 'active')}
        onClick={onButtonClick}
        {...mouseListeners}
      >
        <SVGIcon icon={'fleche_enroulant_une_personne'} />
        <SVGIcon icon={'fleche_personnage_basculant'} />
      </TagActionButton>
      <span className={classNames(s.buttonTooltip, tooltip && 'active')}>
        <T id={'map.tools.upi.tooltip'} />
      </span>
    </div>
  )
}

export default OutdoorButton
